import Head from 'next/head';
import { NextSeo } from 'next-seo';

import { Shipper } from '/screens/';

//vendor
import { SegmentPixel } from 'vendor';

export default function ShipperPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Freight shipping, shipper services, logistics shipping, freight brokerage, shipper technology, shipping software, FTL shipping, LTL shipping, multimodal shopping, PTL, drayage, rail shipping, supply chain services"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Freight Brokerage and Software for Shippers"
        description="Enhance your freight shipping operations with Loadsmart and increase productivity, visibility and efficiency for your business with optimized modes and integrations."
        canonical="https://loadsmart.com/shipper/"
        openGraph={{
          url: 'https://loadsmart.com/shipper/',
        }}
      />
      <Shipper />
      <SegmentPixel />
    </>
  );
}
